export const LANGUAGES = [
  { code: 'en', labelKey: 'langEnglish' },
  { code: 'pl', labelKey: 'langPolish' },
  { code: 'ro', labelKey: 'langRomanian' }
];

export const formatStoreNote = (t, row) => {
  if (!row) return '';

  if (row.noteStatus === 'Shortage') {
    return `${t('notesShortage')} - (${row.qtyPicked ?? ''}) ${t(
      'notesPicked'
    )} - ${t('notesStockDue')} (${row.dueDate ?? ''})`;
  }

  if (row.noteStatus === 'Declined') {
    return `${t('notesDeclined')} - (${row.declineComment ?? ''})`;
  }

  return '';
};
